import { render, staticRenderFns } from "./c_auxiliary_line.vue?vue&type=template&id=287dfedf&scoped=true"
import script from "./c_auxiliary_line.vue?vue&type=script&lang=js"
export * from "./c_auxiliary_line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287dfedf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('287dfedf')) {
      api.createRecord('287dfedf', component.options)
    } else {
      api.reload('287dfedf', component.options)
    }
    module.hot.accept("./c_auxiliary_line.vue?vue&type=template&id=287dfedf&scoped=true", function () {
      api.rerender('287dfedf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_auxiliary_line.vue"
export default component.exports